import { LOGO_BARS, LOGO_COLORS, LOGO_LETTERS, LOGO_P, LOGO_VIEWBOX, MARK_BAR_SHIFT } from './predicoLogo';

// The desktop sidebar wordmark. Collapsing folds it into the Predico mark in
// place: the p never moves, the other letters and the teal bars fade out, and
// the orange bar slides from over the "o" to over the p. The timing matches
// the sidebar's own width transition (duration-300, default easing).
export default function SidebarLogo({ collapsed, className = '' }) {
  const { orange, teal, lightTeal } = LOGO_BARS;
  const fade = collapsed
    ? 'opacity-0 motion-safe:duration-150'
    : 'opacity-100 motion-safe:duration-300 motion-safe:delay-100';

  return (
    <svg viewBox={LOGO_VIEWBOX} className={className} role="img" aria-label="Predico">
      <path d={LOGO_P} fill={LOGO_COLORS.ink} fillRule="evenodd" className="dark:fill-white" />
      <g className={`motion-safe:transition-opacity ${fade}`}>
        {LOGO_LETTERS.map(({ key, color, d }) => (
          <path key={key} d={d} fill={LOGO_COLORS[color]} fillRule="evenodd" className="dark:fill-white" />
        ))}
        <rect {...teal} fill={LOGO_COLORS.teal} className="dark:fill-white" />
        <rect {...lightTeal} fill={LOGO_COLORS.lightTeal} className="dark:fill-white" />
      </g>
      {/* The dark wordmark is all white; the bar turns orange as it lands on
          the p, matching PredicoMark and the favicon. */}
      <rect
        {...orange}
        fill={LOGO_COLORS.orange}
        className={`motion-safe:transition-[transform,fill] motion-safe:duration-300 ${collapsed ? '' : 'dark:fill-white'}`}
        style={{ transform: collapsed ? `translateX(${MARK_BAR_SHIFT}px)` : 'none' }}
      />
    </svg>
  );
}
